import React from "react";
import { ExpressionRule } from "../../rule-engine-core/Expressions/ExpressionRule";

export abstract class ExpressionRuleEditorBase extends React.Component {
    constructor() {
        super({});
    }

    abstract getExpressionRule(): ExpressionRule;
}
